export default __webpack_public_path__ + "static/media/logo.3ea3307c.png";